module.exports = __webpack_public_path__ + "static/background-01b06022d3160c37aa4169f7ef9da52b.png";